export const SET_INITIATING = 'SET_INITIATING';
export const SET_TELECONSULT_SESSION = 'SET_TELECONSULT_SESSION';
export const SET_INVALID_TO_START = 'SET_INVALID_TO_START';
export const SET_INVALID_REASON = 'SET_INVALID_REASON';
